export const ADD_ITEM_TO_CART_REQUEST = 'ADD_ITEM_TO_CART';
export const GET_PRODUCT_DETAILS_SUCCESS = 'GET_PRODUCT_DETAILS_SUCCESS';
export const INIT_GIFT_CARD_BANNER_VALUE = 'INIT_GIFT_CARD_BANNER_VALUE';
export const SHOW_GIFT_CARD_BANNER = 'SHOW_GIFT_CARD_BANNER';
export const ADD_GIFT_CARD_TO_CART_MESSAGE = 'ADD_GIFT_CARD_TO_CART_MESSAGE';
export const UPDATE_GIFT_CARD_BANNER_SELECTED_VALUE = 'UPDATE_GIFT_CARD_BANNER_SELECTED_VALUE';
export const INIT_NEW_GIFT_CARD_BANNER_VALUE = 'INIT_NEW_GIFT_CARD_BANNER_VALUE';
export const INIT_GIFT_CARD_BANNER = 'INIT_GIFT_CARD_BANNER';
export const HIDE_GIFT_CARD_BANNER_MESSAGE = 'HIDE_GIFT_CARD_BANNER_MESSAGE';
